import type { Pinia } from "pinia";
import { createPinia } from "pinia";

export const pinia: Pinia = createPinia();
